import React, { useEffect, useState } from "react";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import dayjs from "dayjs";
import {
  getLPointShowValue,
  getThousandComma,
} from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import { Filters, TotalCount } from "../../../../pages/Users/UserInfo";
import LineBtn from "../../../Button/LineBtn";
import ExcelDownload from "../../../DefaultStyles/ExcelDownload";
import Flex from "../../../DefaultStyles/Flex";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import Pagination from "../../../Table/Pagination";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import CouponPointRegisterModal from "../Coupon/CouponPointRegisterModal";
import pointPromotionData from "../../../../datafiles/lppromotion_set.json";
import { exportJsonToExcel } from "../../../../AdminApi/commFunc";
import styled from "styled-components";
import { authType } from "../../../../pages/Login";
import { useNavigate } from "react-router-dom";
import SpaceBetween from "../../../DefaultStyles/SpaceBetween";

interface IPoint {
  count: string;
  enfodate: string;
  expdate: string;
  id: string;
  promotion: string;
  remain: number;
  type: number;
  uid: string;
  val: number;
}

export const pointHistoryPageState = atom<number>({
  key: "pointHistoryPageState",
  default: 0,
});

export default function PointHistory() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const [savedPage, setSavedPage] = useRecoilState<number>(pointHistoryPageState);

  const [page, setPage] = useState(savedPage);

  useEffect(() => {
    setSavedPage(0);
  }, []);
  const [searchValue, setSearchValue] = useState<string | undefined>("");
  const [dropDownValue, setDropDownValue] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [pointRegisterModal, setPointRegisterModal] = useState(false);

  const { response, fetchData, loading } = useApi({
    method: "get",
    url:
      searchValue !== ""
        ? `point?page=${page}&size=10&${dropDownValue?.value}=${searchValue}`
        : `point?page=${page}&size=10`,
  });

  const tableHead = [
    "ID",
    "UID",
    "Promotion",
    "타입",
    "회차",
    "금액",
    "포인트 잔액",
    "실행 일시",
    "만료일",
  ];

  const getPointTypeString = (type: number) => {
    if (type < 104) {
      return "포인트 적립";
    } else if (type === 104) {
      return "포인트 환불";
    } else if (type === 201) {
      return "포인트 사용";
    } else if (type === 202) {
      return "링키드 머니로 전환";
    } else if (type === 203) {
      return "포인트 만료";
    } else if (type === 204) {
      return "포인트 차감";
    }
  };

  return (
    <>
      <FilterContainer>
        <>
          <Flex gapSize={10}>
            <>
              <DropDown
                setDropDownValue={setDropDownValue}
                dropdownValue={dropDownValue}
              />

              <Search
                setSearchValue={setSearchValue}
                placeholder="입력"
                isDisabled={dropDownValue ? false : true}
                pageResetEvent={() => setPage(0)}
                inputType={
                  dropDownValue?.value === "phone" ||
                  dropDownValue?.value === "uid"
                    ? "number"
                    : undefined
                }
              />
            </>
          </Flex>

          <Flex gapSize={10}>
            <>
              <LineBtn
                icon="file_download"
                btnText="포인트 Promotion ID"
                btnClickEvent={() => {
                  setPage(0);
                  exportJsonToExcel(pointPromotionData, "pointPromotionData");
                }}
              />

              <LineBtn
                icon="add"
                btnText="포인트 지급/차감"
                btnClickEvent={() => setPointRegisterModal(true)}
                disabled={!auth?.couponAndPoint}
              />
            </>
          </Flex>
        </>
      </FilterContainer>

      <LineBox>
        <Table tableHeadData={tableHead} tableMinWidth={879}>
          <>
            {response?.data?.items?.map((d: IPoint) => {
              return (
                <TableBody key={d?.id}>
                  <TableBodyItem>{d?.id}</TableBodyItem>
                  <TableBodyItem
                    clickable={true}
                    onClick={() => {
                      setSavedPage(page);
                      navigate(`/users/info/${d?.uid}`);
                    }}
                  >
                    {d?.uid}
                  </TableBodyItem>
                  <TableBodyItem>{d?.promotion ?? "-"}</TableBodyItem>
                  <TableBodyItem>{getPointTypeString(d?.type)}</TableBodyItem>
                  <TableBodyItem>{d?.count ?? "-"}</TableBodyItem>
                  <TableBodyItem>
                    {d?.type === 104 ||
                    d?.type === 201 ||
                    d?.type === 202 ||
                    d?.type === 204
                      ? "-"
                      : "+"}
                    {getLPointShowValue(d?.val)}
                  </TableBodyItem>
                  <TableBodyItem>{getLPointShowValue(d?.remain)}</TableBodyItem>
                  <TableBodyItem>
                    {dayjs(d?.enfodate)?.format("YYYY-MM-DD HH:mm")}
                  </TableBodyItem>
                  <TableBodyItem>{d?.expdate ?? "-"}</TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>

        <SpaceBetween>
          <Pagination
            totalPage={response?.status === 200 ? response.data.totalPage : 1}
            currentPage={page}
            pageClickEvent={(index) => setPage(index)}
          />

          <TotalCount>
            총{" "}
            {getThousandComma(
              response?.status === 200 ? +response?.data?.totalCount : 0
            )}
            개
          </TotalCount>
        </SpaceBetween>
      </LineBox>

      {pointRegisterModal && (
        <CouponPointRegisterModal
          closeEvent={() => setPointRegisterModal(false)}
          confirmEvent={() => {
            fetchData({
              method: "get",
              url:
                searchValue !== ""
                  ? `point?page=${page}&size=10&${dropDownValue?.value}=${searchValue}`
                  : `point?page=${page}&size=10`,
            });
          }}
          isPoint={true}
        />
      )}

      {loading && <Loader />}

      <ExcelDownload
        tableHead={tableHead.concat(["aa"])}
        pushedData={(e: any) => {
          return [
            e.id,
            e.uid,
            e.promotion,
            getPointTypeString(e?.type),
            e?.count ?? "-",
            (e?.type === 104 || e?.type === 201 || e?.type === 202
              ? "-"
              : "+") + getLPointShowValue(e?.val),
            getLPointShowValue(e?.remain),
            dayjs(e?.enfodate)?.format("YYYY-MM-DD HH:mm"),
            e?.expdate ?? "-",
          ];
        }}
        dataUrl={
          searchValue !== ""
            ? `point?page=0&size=1000&${dropDownValue?.value}=${searchValue}`
            : `point?page=0&size=1000`
        }
        disabled={response?.data?.items?.length < 1}
        title="포인트 내역"
      />
    </>
  );
}

const FilterContainer = styled(Filters)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 12px;

  @media screen and (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;
